module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0029.jpg?v=b057da67";